module.exports = __webpack_public_path__ + "static/media/top-friends-video.c303184e.mp4";